import { ParagraphText, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

export const Disclaimer = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout spacing="$two">
      <ParagraphText css={{ typography: '$caption' }}>
        {formatMessage({ id: 'STR_FOOTER_DISCLAIMER' })}
      </ParagraphText>

      <ParagraphText css={{ typography: '$caption', fontWeight: '500' }}>
        {formatMessage({ id: 'STR_FOOTER_COPYRIGHT' })}
      </ParagraphText>
    </StackLayout>
  );
};
